import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  lineNo: {
    type: "number",
    name: "lineNo",
    label: "Line No",
    errorMsg: "Line No is required.",
    required: true,
    disabled: true,
  },
  orderId: {
    type: "number",
    name: "orderId",
    label: "Order ID",
    errorMsg: "Order ID is required.",
    required: true,
    disabled: true,
  },
  orderDetailsId: {
    type: "number",
    name: "orderDetailsId",
    label: "Order Details ID",
    errorMsg: "Order Details ID is required.",
    required: true,
    disabled: true,
  },
  pickslipId: {
    type: "number",
    name: "pickslipId",
    label: "Pickslip ID",
    errorMsg: "Pickslip ID is required.",
    required: true,
    disabled: true,
  },
  pickslipDetailsId: {
    type: "number",
    name: "pickslipDetailsId",
    label: "Pickslip Details ID",
    errorMsg: "Pickslip Details ID is required.",
    required: true,
    disabled: true,
  },
  skuCode: {
    type: "text",
    name: "skuCode",
    label: "SKU Code",
    maxLength: 50,
    errorMsg: "SKU Code is required.",
    required: true,
    disabled: true,
  },
  vendorCode: {
    type: "text",
    name: "vendorCode",
    label: "Vendor Code",
    maxLength: 50,
    errorMsg: "Vendor Code is required.",
    required: true,
    disabled: true,
  },
  packType: {
    type: "text",
    name: "packType",
    label: "Pack Type",
    maxLength: 10,
    disabled: true,
    required: true,
  },
  skuDescription: {
    type: "text",
    name: "skuDescription",
    label: "SKU Description",
    maxLength: 100,
    disabled: true,
  },
  orderQuantity: {
    type: "number",
    name: "orderQuantity",
    label: "Order Quantity",
    required: true,
    disabled: true,
  },
  shippedQuantity: {
    type: "number",
    name: "shippedQuantity",
    label: "Shipped Quantity",
    required: true,
    disabled: true,
  },
  uom: {
    type: "text",
    name: "uom",
    label: "UOM",
    maxLength: 10,
    required: true,
    // editable: false,
    disabled: true,
  },
  quantity: {
    type: "number",
    name: "quantity",
    label: "Quantity",
    disabled: true,
  },
  baseUOM: {
    type: "text",
    name: "baseUOM",
    label: "Base UOM",
    disabled: true,
  },
  currencyCode: {
    type: "text",
    name: "currencyCode",
    label: "Currency Code",
    maxLength: 10,
    disabled: true,
  },
  unitPrice: {
    type: "number",
    name: "unitPrice",
    label: "Unit Price",
    disabled: true,
    //prefix:"$"
  },
  costPrice: {
    type: "number",
    name: "costPrice",
    label: "Cost Price",
    disabled: true,
    //prefix:"$"
  },
  discountAmount: {
    type: "number",
    name: "discountAmount",
    label: "Discount Amount",
    disabled: true,
  },
  taxAmount: {
    type: "number",
    name: "taxAmount",
    label: "Tax Amount",
    disabled: true,
  },
  mln: {
    type: "text",
    name: "mln",
    label: "MLN",
    maxLength: 20,
    disabled: true,
  },
  cartonID: {
    type: "text",
    name: "cartonID",
    label: "Carton ID",
    maxLength: 20,
    disabled: true,
  },
  expiryDate: {
    //type: "text",
    type: "date",
    name: "expiryDate",
    label: "Expiry Date",
    disabled: true,
  },
  remark: {
    type: "text",
    name: "remark",
    label: "Remark",
    maxLength: 300,
    disabled: true,
  },
  status: {
    type: "text",
    name: "status",
    label: "Status",
    disabled: true,
  },
};

const {
  lineNo,
  orderId,
  orderDetailsId,
  pickslipId,
  pickslipDetailsId,
  skuCode,
  vendorCode,
  packType,
  skuDescription,
  orderQuantity,
  shippedQuantity,
  uom,
  quantity,
  baseUOM,
  currencyCode,
  unitPrice,
  costPrice,
  discountAmount,
  taxAmount,
  mln,
  cartonID,
  expiryDate,
  remark,
  status,
} = formField;

export const detailRender = [
  [skuCode, skuDescription, lineNo, status],
  // [orderId, orderDetailsId],
  // [pickslipId, pickslipDetailsId],
  [vendorCode, packType, orderQuantity, shippedQuantity],
  [baseUOM, uom, quantity, currencyCode],
  [unitPrice, costPrice, mln, expiryDate],
  [discountAmount, taxAmount, cartonID, remark],
];

export const detailValues = getInitialValues(formField);

export const detailValidation = Yup.object().shape({
  // [packageID.name]:Yup.string().nullable().max(packageID.maxLength),
  // [skuCode.name]:Yup.string().nullable().max(skuCode.maxLength).required(skuCode.errorMsg),
  // [packType.name]:Yup.string().nullable().max(packType.maxLength).required(packType.errorMsg),
  // [mln.name]:Yup.string().nullable().max(mln.maxLength),
  // [expiryDate.name]:Yup.string().nullable(),
  // [orderQuantity.name]:Yup.number().min(1,"Order Qty must be greater than 1").integer().required("Order Qty is required"),
  //[uom.name]:Yup.object().shape({"value":Yup.string().nullable(),"label":Yup.string().nullable()}).nullable().required(),
  // [unitPrice.name]:Yup.number().min(0),
  // [currencyCode.name]:Yup.string().nullable().max(currencyCode.maxLength),
  // [discountAmount.name]:Yup.number().min(0),
  // [taxAmount.name]:Yup.number().min(0),
  // [mln.name]:Yup.string().nullable().max(mln.maxLength),
  // [remark.name]:Yup.string().nullable().max(remark.maxLength),
  // [orderShelfLife.name]:Yup.number().min(0),
});
